<form [formGroup]="form" nz-row nzGutter="10" nzJustify="center">
  <un-input
    type="textarea"
    [rows]="5"
    label="Note"
    i18n-label
    formControlName="remark"
    nz-col
    nzXs="24"
    nzSm="24"
    nzMd="16"
  ></un-input>

  <un-input
    type="file"
    [maxLength]="2"
    [multiple]="true"
    label="Attachments"
    i18n-label
    formControlName="attachments"
    nz-col
    nzXs="24"
    nzSm="24"
    nzMd="16"
  ></un-input>

  <div nz-col nzXs="24" nzMd="24" nzOffset="10" class="btn-wrapper m-t-24">
    <un-button
      (click)="submit()"
      class="button-submit"
      size="large"
      type="primary"
      unType="fill"
      [disabled]="form.invalid"
    >
      <span i18n>Add Note</span>
    </un-button>
  </div>
</form>
